import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
} from '@fluentui/react-components';
import { ScaleConfigurationTab } from './ScaleConfigurationTab';
import { RevisionsTab } from './RevisionsTab';
import { RuntimeVersionTab } from './RuntimeVersionTab';
import { useConfigurationTabStyles } from './ConfigurationTab.styles';

export interface ConfigurationTabProps {
  projectName: string;
  appName: string;
}

/**
 * Composite Configuration tab that groups Scale, Revisions, and
 * Runtime Version into collapsible accordion sections.
 */
export const ConfigurationTab = ({ projectName, appName }: ConfigurationTabProps) => {
  const styles = useConfigurationTabStyles();

  return (
    <div className={styles.root}>
      <Accordion
        multiple
        collapsible
        defaultOpenItems={['scale', 'revisions', 'runtime-version']}
        className={styles.accordion}
      >
        <AccordionItem value="scale" className={styles.accordionItem}>
          <AccordionHeader className={styles.accordionHeader}>Scale</AccordionHeader>
          <AccordionPanel className={styles.accordionPanel}>
            <ScaleConfigurationTab projectName={projectName} appName={appName} />
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem value="revisions" className={styles.accordionItem}>
          <AccordionHeader className={styles.accordionHeader}>Revisions</AccordionHeader>
          <AccordionPanel className={styles.accordionPanel}>
            <RevisionsTab projectName={projectName} appName={appName} />
          </AccordionPanel>
        </AccordionItem>

        <AccordionItem value="runtime-version" className={styles.accordionItem}>
          <AccordionHeader className={styles.accordionHeader}>Runtime version</AccordionHeader>
          <AccordionPanel className={styles.accordionPanel}>
            <RuntimeVersionTab projectName={projectName} appName={appName} />
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
